/**
 * Mini router hash-based: #/lobby, #/setup/<gameId>, #/play/<gameId>/<sessionId>
 */

export type Route =
  | { name: 'lobby' }
  | { name: 'setup'; gameId: string }
  | { name: 'play'; gameId: string; sessionId: string };

type Listener = (route: Route) => void;

const listeners: Listener[] = [];

function parse(): Route {
  const hash = location.hash.replace(/^#\//, '');
  const parts = hash.split('/').filter(Boolean);
  if (parts[0] === 'setup' && parts[1]) return { name: 'setup', gameId: parts[1] };
  if (parts[0] === 'play' && parts[1] && parts[2]) {
    return { name: 'play', gameId: parts[1], sessionId: parts[2] };
  }
  return { name: 'lobby' };
}

export function navigate(route: Route): void {
  const hash =
    route.name === 'lobby'
      ? '#/lobby'
      : route.name === 'setup'
        ? `#/setup/${route.gameId}`
        : `#/play/${route.gameId}/${route.sessionId}`;
  if (location.hash === hash) {
    listeners.forEach((l) => l(route));
  } else {
    location.hash = hash;
  }
}

export function onRouteChange(fn: Listener): () => void {
  listeners.push(fn);
  return () => {
    const i = listeners.indexOf(fn);
    if (i >= 0) listeners.splice(i, 1);
  };
}

export function startRouter(): void {
  window.addEventListener('hashchange', () => {
    const r = parse();
    listeners.forEach((l) => l(r));
  });
  if (!location.hash) location.hash = '#/lobby';
  const r = parse();
  queueMicrotask(() => listeners.forEach((l) => l(r)));
}
